import { useQuery } from "@tanstack/react-query";
import type { AuthConfig } from "../types/authConfig";

const fetchAuthConfig = async (): Promise<AuthConfig> => {
  const res = await fetch("/api/v1/auth-config");
  if (!res.ok) throw new Error(`Failed to load auth config: ${res.status}`);
  return res.json();
};

export const useAuthConfigQuery = () => {
  return useQuery({
    queryKey: ["auth-config"],
    queryFn: fetchAuthConfig,
  });
};
